const agGridFontWidthsRelativeToHeight = [
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2796875, 0.2765625,
  0.3546875, 0.5546875, 0.5546875, 0.8890625, 0.665625, 0.190625, 0.3328125, 0.3328125, 0.3890625, 0.5828125, 0.2765625,
  0.3328125, 0.2765625, 0.3015625, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875,
  0.5546875, 0.5546875, 0.5546875, 0.2765625, 0.2765625, 0.584375, 0.5828125, 0.584375, 0.5546875, 1.0140625, 0.665625,
  0.665625, 0.721875, 0.721875, 0.665625, 0.609375, 0.7765625, 0.721875, 0.2765625, 0.5, 0.665625, 0.5546875, 0.8328125,
  0.721875, 0.7765625, 0.665625, 0.7765625, 0.721875, 0.665625, 0.609375, 0.721875, 0.665625, 0.94375, 0.665625,
  0.665625, 0.609375, 0.2765625, 0.3546875, 0.2765625, 0.4765625, 0.5546875, 0.3328125, 0.5546875, 0.5546875, 0.5,
  0.5546875, 0.5546875, 0.2765625, 0.5546875, 0.5546875, 0.221875, 0.240625, 0.5, 0.221875, 0.8328125, 0.5546875,
  0.5546875, 0.5546875, 0.5546875, 0.3328125, 0.5, 0.2765625, 0.5546875, 0.5, 0.721875, 0.5, 0.5, 0.5, 0.3546875,
  0.259375, 0.353125, 0.5890625,
];
const AG_GRID_AVG_RELATIVE_FONT_WIDTH = 0.5279276315789471;
const AG_GRID_FONT_SIZE = 12;
const AG_GRID_PADDING_WIDTH = 24;

const assessedTextWidth = (text: string): number =>
  Array.from(text).reduce(
    (acc, cur) => acc + (agGridFontWidthsRelativeToHeight[cur.charCodeAt(0)] ?? AG_GRID_AVG_RELATIVE_FONT_WIDTH),
    0,
  ) * AG_GRID_FONT_SIZE;

export const isTextOverflowingAgGridCell = (text: string, cellWidth: number): boolean =>
  !!(text && cellWidth && cellWidth - AG_GRID_PADDING_WIDTH < assessedTextWidth(text));
